import { category } from './category';

export const typePolicies = {
  category,
};
